import React from 'react';

let firstAgeRemoved = false
let firstWeightRemoved = false

function hasClass(element, className) {
	return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}

// var show = function (elem) {
// 	// Get the natural height of the element
// 	if (hasClass(elem, 'is-visible')){
// 		hide(elem);
// 	}else{
// 		var getHeight = function () {
// 			elem.style.display = 'block'; // Make it visible
// 			var height = elem.scrollHeight + 'px'; // Get it's height
// 			elem.style.display = ''; //  Hide it again
// 			return height;
// 		};

// 		var height = getHeight(); // Get the natural height
// 		elem.classList.add('is-visible'); // Make the element visible
// 		elem.style.height = height; // Update the max-height

// 		// Once the transition is complete, remove the inline max-height so the content can scale responsively
// 		window.setTimeout(function () {
// 			elem.style.height = '';
// 		}, 350);
// 	}
// };

// // Hide an element
// var hide = function (elem) {

// 	// Give the element a height to change from
// 	elem.style.height = elem.scrollHeight + 'px';

// 	// Set the height back to 0
// 	window.setTimeout(function () {
// 		elem.style.height = '36px';
// 	}, 1);

// 	// When the transition is complete, hide it
// 	window.setTimeout(function () {
// 		elem.classList.remove('is-visible');
// 	}, 350);

// };

class GettingStarted extends React.Component {

	constructor(props){
		// Pass props to parent class
		super(props);
		// Set initial state
		this.state = {
			sumbmitActive: false,
			age: 'My baby is...',
			ageDropDown: false,
			ageOption: '',
			time: 'I plan to use Esembly...',
			weight: 'My baby weighs...',
			weightDropDown: false,
			timeDropDown: false,
			weightOption: '',
			timeOption: ''
		}

		this.setAge = this.setAge.bind(this);
		this.setTime = this.setTime.bind(this);
		this.setWeight = this.setWeight.bind(this);
		this.buildHandleDataAndFilterDiaperProducts = this.buildHandleDataAndFilterDiaperProducts.bind(this);
		this.evaluateProgressionButton = this.evaluateProgressionButton.bind(this);
		this.openAgeDropdown = this.openAgeDropdown.bind(this);
		this.openWeightDropdown = this.openWeightDropdown.bind(this);
		this.openTimeDropdown = this.openTimeDropdown.bind(this);
		this.openAgeDropdownAccessibility = this.openAgeDropdownAccessibility.bind(this);
		this.openWeightDropdownAccessibility = this.openWeightDropdownAccessibility.bind(this);
		this.openTimeDropdownAccessibility = this.openTimeDropdownAccessibility.bind(this);
		this.setWeightAccessibility = this.setWeightAccessibility.bind(this);
		this.setAgeAccessibility = this.setAgeAccessibility.bind(this);
		this.buildHandleDataAndFilterDiaperProductsAccessibility = this.buildHandleDataAndFilterDiaperProductsAccessibility.bind(this);
		this.setTimeAccessibility = this.setTimeAccessibility.bind(this);
	}

	evaluateProgressionButton(){
		if (this.state.age !== "My baby is..." && this.state.weight !== "My baby weighs..." && this.state.time !== "I plan to use Esembly..."){
			this.setState({
				sumbmitActive: true
			});
		}
	}

	setAge(e){

		var elements = document.getElementsByClassName('age-option');

		for (var i = 0; i < elements.length; i++) {
			elements[i].removeAttribute("style");
		}

		e.currentTarget.style.display = 'none';

		this.setState({
			age: e.currentTarget.textContent,
			ageDropDown: false,
			ageOption: e.currentTarget.dataset.value

		}, () => {
			this.evaluateProgressionButton();
			for (var i = 0; i < elements.length; i++) {
				//elements[i].tabIndex = -1
			}
		});

		// hide(document.getElementById("time-dropdown"));
		// hide(document.getElementById("age-dropdown"));
		// hide(document.getElementById("weight-dropdown"));

	}


	setTime(e){

		var elements = document.getElementsByClassName('time-option');

		for (var i = 0; i < elements.length; i++) {
			elements[i].removeAttribute("style");
		}

		e.currentTarget.style.display = 'none';

		this.setState({
			time: e.currentTarget.textContent,
			timeDropDown: false,
			timeOption: e.currentTarget.dataset.value

		}, () => {
			this.evaluateProgressionButton();
			for (var i = 0; i < elements.length; i++) {
				//elements[i].tabIndex = -1
			}
		});

		// hide(document.getElementById("time-dropdown"));
		// hide(document.getElementById("age-dropdown"));
		// hide(document.getElementById("weight-dropdown"));

	}

	openAgeDropdownAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.openAgeDropdown(e);
		}
	}

	openWeightDropdownAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.openWeightDropdown(e);
		}
	}

	openTimeDropdownAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.openTimeDropdown(e);
		}
	}

	setAgeAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.setAge(e);
		}
	}

	setWeightAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.setWeight(e);
		}
	}

	setTimeAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.setTime(e);
		}
	}

	buildHandleDataAndFilterDiaperProductsAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.buildHandleDataAndFilterDiaperProducts(e);
		}
	}

	setWeight(e){

		var elements = document.getElementsByClassName('weight-option');

		for (var i = 0; i < elements.length; i++) {
			elements[i].removeAttribute("style");
		}

		e.currentTarget.style.display = 'none';

		this.setState({
			weight: e.currentTarget.textContent,
			weightDropDown: false,
			weightOption: e.currentTarget.dataset.value
		}, () => {
			this.evaluateProgressionButton();
			for (var i = 0; i < elements.length; i++) {
				//elements[i].tabIndex = -1
			}
		});
		// hide(document.getElementById("age-dropdown"));
		// hide(document.getElementById("weight-dropdown"));
		// hide(document.getElementById("time-dropdown"));

	}

	openAgeDropdown(event){
		var elements = document.getElementsByClassName('weight-option');

		for (var i = 0; i < elements.length; i++) {
			//elements[i].tabIndex = -1
		}

		var elements = document.getElementsByClassName('time-option');

		for (var i = 0; i < elements.length; i++) {
			//elements[i].tabIndex = -1
		}

		var elements = document.getElementsByClassName('age-option');

		for (var i = 0; i < elements.length; i++) {
			//elements[i].tabIndex = 0
		}

		this.setState({
			ageDropDown: true,
			timeDropDown: false,
			weightDropDown: false
		});
		// hide(document.getElementById("time-dropdown"));
		// hide(document.getElementById("weight-dropdown"));
		// show(document.getElementById("age-dropdown"));
	}

	openWeightDropdown(){

		var elements = document.getElementsByClassName('age-option');

		for (var i = 0; i < elements.length; i++) {
			//elements[i].tabIndex = -1
		}

		var elements = document.getElementsByClassName('time-option');

		for (var i = 0; i < elements.length; i++) {
			//elements[i].tabIndex = -1
		}


		var elements = document.getElementsByClassName('weight-option');

		for (var i = 0; i < elements.length; i++) {
			//elements[i].tabIndex = 0
		}

		this.setState({
			weightDropDown: true,
			ageDropDown: false,
			timeDropDown: false
		});
		// hide(document.getElementById("time-dropdown"));
		// hide(document.getElementById("age-dropdown"));
		// show(document.getElementById("weight-dropdown"));
	}

	openTimeDropdown(){

		var elements = document.getElementsByClassName('age-option');

		for (var i = 0; i < elements.length; i++) {
			//elements[i].tabIndex = -1
		}

		var elements = document.getElementsByClassName('weight-option');

		for (var i = 0; i < elements.length; i++) {
			//elements[i].tabIndex = -1
		}


		var elements = document.getElementsByClassName('time-option');

		for (var i = 0; i < elements.length; i++) {
			//elements[i].tabIndex = 0
		}

		this.setState({
			weightDropDown: false,
			ageDropDown: false,
			timeDropDown: true
		});

		// hide(document.getElementById("age-dropdown"));
		// hide(document.getElementById("weight-dropdown"));
		// show(document.getElementById("time-dropdown"));
	}

	buildHandleDataAndFilterDiaperProducts(event){
		if (this.state.sumbmitActive) {
			var ageObject, size
			var age = this.state.ageOption
			var weight = this.state.weightOption
			var time = this.state.timeOption
			var suggestedQuantityOptions = 0;
			var suggestedQuantity = 0;
			if (age === "age-1"){
				suggestedQuantity = 0;
				if(time === "time-2"){
					suggestedQuantity = 4;
				}
			}else if(age === "age-2"){
				suggestedQuantity = 1;
				if(time === "time-2"){
					suggestedQuantity = 5;
				}
			}else if(age === "age-3"){
				suggestedQuantity = 2;
				if(time === "time-2"){
					suggestedQuantity = 6;
				}
			}else if(age === "age-4"){
				suggestedQuantity = 3;
				if(time === "time-2"){
					suggestedQuantity = 7;
				}
			}else{
				suggestedQuantity = 0;
			}



			if (age === "age-1" || age === "age-2"){
				ageObject = [
					{
						handle: 'inner-diaper'
					},
					{
						handle: 'outer-cover'
					},
					{
						handle: 'stay-dry-fleece-liners'
					},
					{
						handle: 'overnighter'
					},
					{
						handle: 'flushers'
					},
					{
						handle: 'wipe-ups'
					},
					{
						handle: 'tossers'
					}
				]
			} else if (age === "age-3") {
				ageObject = [
					{
						handle: 'inner-diaper'
					},
					{
						handle: 'outer-cover'
					},
					{
						handle: 'overnighter'
					},
					{
						handle: 'stay-dry-fleece-liners'
					},
					{
						handle: 'flushers'
					},
					{
						handle: 'wipe-ups'
					},
					{
						handle: 'tossers'
					}
				]
			} else if (age === "age-4") {
				ageObject = [
					{
						handle: 'inner-diaper'
					},
					{
						handle: 'outer-cover'
					},
					{
						handle: 'overnighter'
					},
					{
						handle: 'stay-dry-fleece-liners'
					},
					{
						handle: 'flushers'
					},
					{
						handle: 'wipe-ups'
					},
					{
						handle: 'tossers'
					}
				]
			}

			if (weight === "weight-3") {
				size = "Two"
			} else {
				size = "One"
			}

			console.log(suggestedQuantity)

			this.props.filterDiaperingProductsByHandles(ageObject, size, suggestedQuantity);
		}
	}

	componentDidMount(){
		window.addEventListener('click', function(e){
			if (document.getElementById('weight-dropdown').contains(e.target) || document.getElementById('age-dropdown').contains(e.target) || document.getElementById('time-dropdown').contains(e.target)){
				// Clicked in box
			}else{
				// hide(document.getElementById("age-dropdown"));
				// hide(document.getElementById("weight-dropdown"));
				// hide(document.getElementById("time-dropdown"));
			}

		});

			var container;
			var trigger;
			var selectedText;
			var optionsList;
			var options;
			var hiddenField;
			var isExpanded = false;

			// window.addEventListener('DOMContentLoaded', function(e) {
			  container = document.querySelector('.csdd');
			  trigger = document.querySelector('.csdd .trigger');
			  selectedText = document.getElementById('selected-text');
			  optionsList = document.querySelector('.csdd .options');  
			  options = document.querySelectorAll('.csdd .options li');
			  hiddenField = document.getElementById('hidden-field');
			  
			  // Handle keyboard and mouse interactions on the trigger bar
			  trigger.addEventListener('keydown', handleTriggerKeypresses);
			  trigger.addEventListener('click', handleTriggerClick);
			  
			  // Select options when they are clicked
			  options.forEach(function(option) {
			    option.addEventListener('click', function(e) {
			      unselectAllOptions();
			      selectOption(e.target);
			      collapseOptions();
			      trigger.focus();
			    });
			  });
			  
			  // Collapse the dropdown when the user clicks off
			  document.addEventListener('click', handleBodyClick);
			  
			  
			// });


			/**
			  Event handlers
			*/
			function handleTriggerKeypresses(e) {
			  switch(e.key) {
			    case 'ArrowUp':
			      e.preventDefault();
			      
			      if(isExpanded) {
			        selectPreviousOption();
			      } else {
			        expandOptions();
			      }
			      
			      break;
			      
			    case 'ArrowDown':
			      e.preventDefault();
			      
			      if(isExpanded) {
			        selectNextOption();
			      } else {
			        expandOptions();
			        selectFirstOption();
			      }
			      
			      break;
			      
			    case 'Home':
			      if(isExpanded) {
			        selectFirstOption();
			      }
			      
			      break;
			      
			    case 'End':
			      if(isExpanded) {
			        selectLastOption();
			      }
			      
			      break;
			      
			    case 'Tab':
			      collapseOptions();
			      break;
			      
			    case 'Escape':
			    case 'Enter':
			      if(isExpanded) {
			        e.preventDefault();
			        collapseOptions();
			      }
			      
			      break;
			  }
			}

			function handleBodyClick(e) {
			  if(!container.contains(e.target) && isExpanded) {
			    collapseOptions();
			  }
			}

			function handleTriggerClick() {
			  if(isExpanded) {
			    collapseOptions();
			    trigger.focus();
			  } else {
			    expandOptions();
			  }
			}


			/**
			  Show/hide option list
			*/
			function collapseOptions() {
			  trigger.setAttribute('aria-expanded', false);
			  optionsList.classList.remove('is-visible');
			  container.parentNode.style.height = "36px";
			  isExpanded = false;
			}

			function expandOptions() {
			  trigger.setAttribute('aria-expanded', true);
			  optionsList.classList.add('is-visible');
			  var offsetHeight1 = optionsList.offsetHeight;
			  container.parentNode.style.height = 36 + offsetHeight1 + "px";
			  isExpanded = true;
			}


			/**
			  Option selection
			*/
			function selectFirstOption() {
			  var firstOption = options[0];
			  selectOption(firstOption);
			}

			function selectLastOption() {
			  var lastOption = options[options.length-1];
			  selectOption(lastOption);
			}

			function selectNextOption() {
			  var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
			  
			  if(currentOption !== undefined) {
			    var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
			    
			    if(currentOptionIndex + 1 < options.length) {
			      var nextOption = options[currentOptionIndex + 1];
			      selectOption(nextOption);
			    }
			  }
			}

			function selectPreviousOption() {
			  var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
			  
			  if(currentOption !== undefined) {
			    var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
			    
			    if(currentOptionIndex - 1 >= 0) {
			      var previousOption = options[currentOptionIndex - 1];
			      selectOption(previousOption);
			    }
			  }
			}

			var selectOption = (option) => {
			  unselectAllOptions();
			  option.setAttribute('aria-selected', true);
			  trigger.setAttribute('aria-activedescendant', option.getAttribute('id'));
			  selectedText.innerHTML = option.innerHTML;
			  this.setState({
			  	age: option.innerHTML,
				ageOption: option.getAttribute('id')
			  }, () => {
			  	this.evaluateProgressionButton()
			  });
			}

			function unselectAllOptions() {  
			  options.forEach(function(option) {
			    option.removeAttribute('aria-selected');
			  });
			}




			var container2;
			var trigger2;
			var selectedText2;
			var optionsList2;
			var options2;
			var isExpanded2 = false;

			// window.addEventListener('DOMContentLoaded', function(e) {
			  container2 = document.querySelector('.csdd2');
			  trigger2 = document.querySelector('.csdd2 .trigger2');
			  selectedText2 = document.getElementById('selected-text2');
			  optionsList2 = document.querySelector('.csdd2 .options2');  
			  options2 = document.querySelectorAll('.csdd2 .options2 li');
			  
			  // Handle keyboard and mouse interactions on the trigger bar
			  trigger2.addEventListener('keydown', handleTriggerKeypresses2);
			  trigger2.addEventListener('click', handleTriggerClick2);
			  
			  // Select options when they are clicked
			  options2.forEach(function(option) {
			    option.addEventListener('click', function(e) {
			      unselectAllOptions2();
			      selectOption2(e.target);
			      collapseOptions2();
			      trigger2.focus();
			    });
			  });
			  
			  // Collapse the dropdown when the user clicks off
			  document.addEventListener('click', handleBodyClick2);
			  
			  
			// });


			/**
			  Event handlers
			*/
			function handleTriggerKeypresses2(e) {
			  switch(e.key) {
			    case 'ArrowUp':
			      e.preventDefault();
			      
			      if(isExpanded2) {
			        selectPreviousOption2();
			      } else {
			        expandOptions2();
			      }
			      
			      break;
			      
			    case 'ArrowDown':
			      e.preventDefault();
			      
			      if(isExpanded2) {
			        selectNextOption2();
			      } else {
			        expandOptions2();
			        selectFirstOption2();
			      }
			      
			      break;
			      
			    case 'Home':
			      if(isExpanded2) {
			        selectFirstOption2();
			      }
			      
			      break;
			      
			    case 'End':
			      if(isExpanded2) {
			        selectLastOption2();
			      }
			      
			      break;
			      
			    case 'Tab':
			      collapseOptions2();
			      break;
			      
			    case 'Escape':
			    case 'Enter':
			      if(isExpanded2) {
			        e.preventDefault();
			        collapseOptions2();
			      }
			      
			      break;
			  }
			}

			function handleBodyClick2(e) {
			  if(!container2.contains(e.target) && isExpanded2) {
			    collapseOptions2();
			  }
			}

			function handleTriggerClick2() {
			  if(isExpanded2) {
			    collapseOptions2();
			    trigger2.focus();
			  } else {
			    expandOptions2();
			  }
			}


			/**
			  Show/hide option list
			*/
			function collapseOptions2() {
			  trigger2.setAttribute('aria-expanded', false);
			  container2.parentNode.style.height = "36px";
			  setTimeout(() => {
				  optionsList2.classList.remove('is-visible');
				}, 350)
			  isExpanded2 = false;
			}

			function expandOptions2() {
			  trigger2.setAttribute('aria-expanded', true);
			  optionsList2.classList.add('is-visible');
			  var offsetHeight2 = optionsList2.offsetHeight;
			  container2.parentNode.style.height = 36 + offsetHeight2 + "px";
			  isExpanded2 = true;
			}


			/**
			  Option selection
			*/
			function selectFirstOption2() {
			  var firstOption2 = options2[0];
			  selectOption2(firstOption2);
			}

			function selectLastOption2() {
			  var lastOption2 = options2[options2.length-1];
			  selectOption2(lastOption2);
			}

			function selectNextOption2() {
			  var currentOption2 = document.getElementById(trigger2.getAttribute('aria-activedescendant'));
			  
			  if(currentOption2 !== undefined) {
			    var currentOptionIndex2 = Array.prototype.slice.call(options2).indexOf(currentOption2);
			    
			    if(currentOptionIndex2 + 1 < options2.length) {
			      var nextOption2 = options2[currentOptionIndex2 + 1];
			      selectOption2(nextOption2);
			    }
			  }
			}

			function selectPreviousOption2() {
			  var currentOption2 = document.getElementById(trigger2.getAttribute('aria-activedescendant'));
			  
			  if(currentOption2 !== undefined) {
			    var currentOptionIndex2 = Array.prototype.slice.call(options2).indexOf(currentOption2);
			    
			    if(currentOptionIndex2 - 1 >= 0) {
			      var previousOption2 = options2[currentOptionIndex2 - 1];
			      selectOption2(previousOption2);
			    }
			  }
			}

			var selectOption2 = (option) => {
			  unselectAllOptions2();
			  option.setAttribute('aria-selected', true);
			  trigger2.setAttribute('aria-activedescendant', option.getAttribute('id'));
			  selectedText2.innerHTML = option.innerHTML;
			  this.setState({
			  	weight: option.innerHTML,
				weightOption: option.getAttribute('id')
			  }, () => {
			  	this.evaluateProgressionButton()
			  });
			  
			}

			function unselectAllOptions2() {  
			  options2.forEach(function(option) {
			    option.removeAttribute('aria-selected');
			  });
			}


			var container3;
			var trigger3;
			var selectedText3;
			var optionsList3;
			var options3;
			var isExpanded3 = false;

			// window.addEventListener('DOMContentLoaded', function(e) {
			  container3 = document.querySelector('.csdd3');
			  trigger3 = document.querySelector('.csdd3 .trigger3');
			  selectedText3 = document.getElementById('selected-text3');
			  optionsList3 = document.querySelector('.csdd3 .options3');  
			  options3 = document.querySelectorAll('.csdd3 .options3 li');
			  
			  // Handle keyboard and mouse interactions on the trigger bar
			  trigger3.addEventListener('keydown', handleTriggerKeypresses3);
			  trigger3.addEventListener('click', handleTriggerClick3);
			  
			  // Select options when they are clicked
			  options3.forEach(function(option) {
			    option.addEventListener('click', function(e) {
			      unselectAllOptions3();
			      selectOption3(e.target);
			      collapseOptions3();
			      trigger3.focus();
			    });
			  });
			  
			  // Collapse the dropdown when the user clicks off
			  document.addEventListener('click', handleBodyClick3);
			  
			  
			// });


			/**
			  Event handlers
			*/
			function handleTriggerKeypresses3(e) {
			  switch(e.key) {
			    case 'ArrowUp':
			      e.preventDefault();
			      
			      if(isExpanded3) {
			        selectPreviousOption3();
			      } else {
			        expandOptions3();
			      }
			      
			      break;
			      
			    case 'ArrowDown':
			      e.preventDefault();
			      
			      if(isExpanded3) {
			        selectNextOption3();
			      } else {
			        expandOptions3();
			        selectFirstOption3();
			      }
			      
			      break;
			      
			    case 'Home':
			      if(isExpanded3) {
			        selectFirstOption3();
			      }
			      
			      break;
			      
			    case 'End':
			      if(isExpanded3) {
			        selectLastOption3();
			      }
			      
			      break;
			      
			    case 'Tab':
			      collapseOptions3();
			      break;
			      
			    case 'Escape':
			    case 'Enter':
			      if(isExpanded3) {
			        e.preventDefault();
			        collapseOptions3();
			      }
			      
			      break;
			  }
			}

			function handleBodyClick3(e) {
			  if(!container3.contains(e.target) && isExpanded3) {
			    collapseOptions3();
			  }
			}

			function handleTriggerClick3() {
			  if(isExpanded3) {
			    collapseOptions3();
			    trigger3.focus();
			  } else {
			    expandOptions3();
			  }
			}


			/**
			  Show/hide option list
			*/
			function collapseOptions3() {
			  trigger3.setAttribute('aria-expanded', false);
			  optionsList3.classList.remove('is-visible');
			  container3.parentNode.style.height = "36px";
			  isExpanded3 = false;
			}

			function expandOptions3() {
			  trigger3.setAttribute('aria-expanded', true);
			  optionsList3.classList.add('is-visible');
			  var offsetHeight3 = optionsList3.offsetHeight;
			  container3.parentNode.style.height = 36 + offsetHeight3 + "px";
			  isExpanded3 = true;
			}


			/**
			  Option selection
			*/
			function selectFirstOption3() {
			  var firstOption3 = options3[0];
			  selectOption3(firstOption3);
			}

			function selectLastOption3() {
			  var lastOption3 = options3[options3.length-1];
			  selectOption3(lastOption3);
			}

			function selectNextOption3() {
			  var currentOption3 = document.getElementById(trigger3.getAttribute('aria-activedescendant'));
			  
			  if(currentOption3 !== undefined) {
			    var currentOptionIndex3 = Array.prototype.slice.call(options3).indexOf(currentOption3);
			    
			    if(currentOptionIndex3 + 1 < options3.length) {
			      var nextOption3 = options3[currentOptionIndex3 + 1];
			      selectOption3(nextOption3);
			    }
			  }
			}

			function selectPreviousOption3() {
			  var currentOption3 = document.getElementById(trigger3.getAttribute('aria-activedescendant'));
			  
			  if(currentOption3 !== undefined) {
			    var currentOptionIndex3 = Array.prototype.slice.call(options3).indexOf(currentOption3);
			    
			    if(currentOptionIndex3 - 1 >= 0) {
			      var previousOption3 = options3[currentOptionIndex3 - 1];
			      selectOption3(previousOption3);
			    }
			  }
			}

			var selectOption3 = (option) => {
			  unselectAllOptions3();
			  option.setAttribute('aria-selected', true);
			  trigger3.setAttribute('aria-activedescendant', option.getAttribute('id'));
			  selectedText3.innerHTML = option.innerHTML;
			  this.setState({
			  	time: option.innerHTML,
				timeOption: option.getAttribute('id')
			  }, () => {
			  	this.evaluateProgressionButton()
			  });
			  // Scroll item into view
			  
			  
			  // Update the hidden field
			  //hiddenField.value = option.innerHTML;
			}

			function unselectAllOptions3() {  
			  options3.forEach(function(option) {
			    option.removeAttribute('aria-selected');
			  });
			}

	}

	render() {
		return (
			<div className={(this.props.active ? 'active getting-started' : 'getting-started')} id="panel">
				<div className="inner">
					<h1>Let us help you<br/>build your bundle</h1>
					
					<div className="divider-dots" aria-hidden="true">
						<i className="es-icon icon-carousel-dot-1icon divider"></i>
						<i className="es-icon icon-carousel-dot-1icon divider"></i>
						<i className="es-icon icon-carousel-dot-1icon divider"></i>
						<i className="es-icon icon-carousel-dot-1icon divider"></i>
					</div>

					<p>Simply answer the questions below and we'll make product and quantity recommendations based on your answers. You'll have the ability to select your colors/prints and make adjustments as you go along.</p>


					<div className={(this.state.ageDropDown ? 'active dropdown-wrapper' : 'dropdown-wrapper')}>
						<div id="age-dropdown" className="drop-down" style={{"height" : "36px"}}>
							<div class="csdd">
							  <button
							    role="combobox"
							    aria-haspopup="listbox"
							    aria-labelledby="label selected-text"
							    aria-expanded="false"
							    id="trigger"
							    className="trigger default"
							    onClick={this.openAgeDropdown}
							  >
							    <span id="selected-text">{this.state.age}</span>
							    <div className="arrow" aria-hidden="true"></div>
							  </button>

							  <ul 
							    className="options"
							    role="listbox"
							    aria-labelledby="label"
							  >
							    <li role="option" className="age-option" id="age-1" data-value="age-1" >Not yet born</li>
							    <li role="option" className="age-option" id="age-2" data-value="age-2" >0 - 4 months</li>
							    <li role="option" className="age-option" id="age-3" data-value="age-3" >5 - 14 months</li>
							    <li role="option" className="age-option" id="age-4" data-value="age-4" >14+ months</li>
							  </ul>
							</div>
						</div>
					</div>

					<div className={(this.state.weightDropDown ? 'active dropdown-wrapper' : 'dropdown-wrapper')}>

						<div id="weight-dropdown" className="drop-down" style={{"height" : "36px"}}>
							<div class="csdd2">
							  <button
							    role="combobox"
							    aria-haspopup="listbox"
							    aria-labelledby="label selected-text2"
							    aria-expanded="false"
							    id="trigger2"
							    className="trigger2 default"
							    onClick={this.openWeightDropdown}
							  >
							    <span id="selected-text2">{this.state.weight}</span>
							    <div className="arrow" aria-hidden="true"></div>
							  </button>

							  <ul 
							    className="options2"
							    role="listbox"
							    aria-labelledby="label"
							  >
							    <li role="option" className="weight-option" id="weight-1" data-value="weight-1" >Too soon to tell</li>
							    <li role="option" className="weight-option" id="weight-2" data-value="weight-2" >7-17 lbs (4-8 kg)</li>
							    <li role="option" className="weight-option" id="weight-3" data-value="weight-3" >17-35 lbs (8-16 kg)</li>
							    
							  </ul>
							</div>
						</div>

					</div>

					<div className={(this.state.timeDropDown ? 'active dropdown-wrapper' : 'dropdown-wrapper')}>
						<div id="time-dropdown" className="drop-down" style={{"height" : "36px"}}>
						
							<div class="csdd3">
								<button
									role="combobox"
									aria-haspopup="listbox"
									aria-labelledby="label selected-text3"
									aria-expanded="false"
									id="trigger3"
									className="trigger3 default"
									onClick={this.openTimeDropdown}
								>
									<span id="selected-text3">{this.state.time}</span>
									<div className="arrow" aria-hidden="true"></div>
								</button>

								<ul 
									className="options3"
									role="listbox"
									aria-labelledby="label"
								>
									<li role="option" className="time-option" id="time-1" data-value="time-1">Full-time</li>
									<li role="option" className="time-option" id="time-2" data-value="time-2">Part-time</li>

								</ul>
							</div>
						</div>
					</div>

					<button disabled={(this.state.sumbmitActive ? false : true)} className={(this.state.sumbmitActive ? 'progress-cta es-btn' : 'progress-cta inactive es-btn')} onClick={this.buildHandleDataAndFilterDiaperProducts} onKeyPress={e => this.buildHandleDataAndFilterDiaperProductsAccessibility(e)}>
						Build your system
					</button>
				</div>
			</div>
		)
	}
};

export default GettingStarted;